import { FormikProps } from 'formik';
import * as React from 'react';

import { Option, PeopleProfileInstitutionFormType, PeopleProfileOrganisationFormType } from '../../../../utils/types';
import { OrganisationsCard } from './organisationsCard';
import { PersonDetailsFormType } from '../forms/PersonDetailsForm';

type FormType = PersonDetailsFormType & {
  typeId: Option | undefined;
  portal: string;

  dateOfBirth: Date | null;
  emisNumber: number | undefined;
  name: string;

  primaryInstitutionId: Option | undefined;
  institutionIds: Option[];
  associatedInstitutions: PeopleProfileInstitutionFormType[];
  associatedOrganisations: PeopleProfileOrganisationFormType[];
};

type Props = {
  formikProps: FormikProps<FormType>;
  userRoles?: any;
};

const FieldsForPractitioner: React.FC<Props> = props => {
  const { formikProps } = props;

  // const canLinkInstitutions = ['INSTITUTION_ADMIN', 'INSTITUTION_MEMBER'].some(
  //   (item: any) => userRoles && userRoles.includes(item)
  // );

  return (
    <React.Fragment>
      <OrganisationsCard
        formikProps={formikProps}
        // viewMode={formikProps.values.portal !== 'admin'}
        currentOrganisationsOnly={formikProps.values.portal !== 'admin'}
      />
    </React.Fragment>
  );
};

export default FieldsForPractitioner;
